@import '../../../../../constants/spacing.module.less';

.receive-button {
  height: 24px;
}
